import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';
import CircleTimer from '../CircleTimer/CircleTimer';

// eslint-disable-next-line css-modules/no-unused-class
import s from './../LeasingOnlineBanner.css';

class ResultForm extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    time: PropTypes.number,
    approved: PropTypes.bool.isRequired,
    timeUp: PropTypes.func,
  };

  static defaultProps = {
    time: 300,
    timeUp: () => {},
  };

  render() {
    const { t, approved, timeUp, time } = this.props;
    return (
      <div className={s.containerCenter}>
        <div className={s.containerResultTitle}>
          {t('Спасибо!')}
        </div>
        {approved &&
          <div className={s.containerTextBlock}>
            {t('Ваша заявка одобрена!')} <br />
            {/*{t('В течении 2 минут Вам придут')} <br />*/}
            {/*<b> {t('подтверждающие документы')}</b>*/}
          </div>}
        {!approved &&
          <div className={s.containerTextBlock}>
            {t('LEASING_FORM_RESULT_RQ_QUIESTINS')}
          </div>}
        <div className={s.containerCircleTimer}>
          <CircleTimer time={time} timeUp={timeUp} />
        </div>
        <div className={s.containerTextBlock}>
          {t('В течении')} <b> 5 {t('минут')}</b> {t('с Вами свяжется менеджер')}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(ResultForm));



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/ResultForm/ResultForm.js